import { useEffect, useState } from 'react';
import { desktop, isDesktop, type SyncStatus } from './bridge';

/**
 * État de la connexion, tenu à jour par le processus principal.
 *
 * Rend `null` dans le navigateur : il n'y a rien à afficher là-bas, où la
 * page ne fonctionne de toute façon qu'avec le serveur en face.
 *
 * L'état n'est pas déduit de `navigator.onLine`. Celui-ci dit que la machine
 * a une carte réseau active, pas que le serveur DiagFlow répond — un portable
 * relié au réseau d'un chantier sans route vers le serveur y apparaîtrait
 * connecté alors que rien ne remonte. La valeur vient du résultat réel du
 * dernier échange.
 */
export function useSyncStatus(): SyncStatus | null {
  const [status, setStatus] = useState<SyncStatus | null>(null);

  useEffect(() => {
    if (!isDesktop()) return;

    let active = true;
    const bridge = desktop();

    bridge.sync
      .status()
      .then((initial) => {
        if (active) setStatus(initial);
      })
      .catch(() => {
        // le pont ne répond pas : l'indicateur reste vide plutôt que de mentir
      });

    const unsubscribe = bridge.sync.subscribe((next) => {
      if (active) setStatus(next);
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return status;
}
